/* eslint-disable jsx-a11y/anchor-is-valid */
import React from "react";
import { FC } from 'react'
import rideApi from "../../modules/tp/rides/_requests";
import { Ride } from "../../modules/tp/rides/_models";
import { icon, singleEntityName, pluralEntityName, dateFormat } from "../../modules/tp/rides/_constants";
import { Column } from "app/partials/entity/Table";
import PageWrapper from "app/partials/entity/PageWrapper";
import RideFormBuilder from "../../modules/tp/rides/builders/RideFormBuilder";
import moment from 'moment';
import { timeFormat } from "../../partials/form/DatetimeRangeInput";
import { emptyService, Service } from "app/modules/tp/services/_models";
import serviceApi from "../../modules/tp/services/_requests";

export const columns: Array<Column<Ride>> = [
    //{
    //    key: "id",
    //    label: "# ID",
    //},
    //{
    //    key: "service",
    //    label: "Titolo Servizio",
    //    render: (ride: Ride) => (<>{ride.serviceObj?.title}</>),
    //},
    //{
    //    key: "client",
    //    label: "Cliente",
    //    render: (ride: Ride) => (<>{ride.serviceObj?.client?.displayed_name ?? ride.serviceObj?.client?.business_name }</>),
    //},
    {
        key: "itinerary",
        label: "Itinerario",
        filterable: true,
        sortable: true,
        render: (ride: Ride) => (<>{ride?.itinerary ?? ""}</>),
    },
    {
        key: "start_departure_date",
        label: "Data inizio",
        filterable: true,
        sortable: true,
        render: (ride: Ride) => (<>{ride.start_departure_date ? moment(ride.start_departure_date, "DD/MM/YYYY HH:mm").format(`${dateFormat} ${timeFormat}`) : ''}</>),
    },
    {
        key: "end_departure_date",
        label: "Data fine",
        filterable: true,
        sortable: true,
        render: (ride: Ride) => (<>{ride.end_departure_date ? moment(ride.end_departure_date, "DD/MM/YYYY HH:mm").format(`${dateFormat} ${timeFormat}`) : ''}</>),
    },
    {
        key: "provider",
        label: "Fornitore",
        filterOn: 'name',
        filterable: true,
        render: (ride: Ride) => (<>{`${ride?.provider?.name?? ""} ${ride?.provider?.surname ?? ""}` }</>),
    },
    {
        key: "referent",
        label: "Referente",
        filterOn: 'surname',
        filterable: true,
        render: (ride: Ride) => (<>{ride.referent?.name} {ride.referent?.surname}</>),
    },
    {
        key: "mean",
        label: "Mezzo",
        filterable: true,
        filterOn: 'license_plate',
        render: (ride: Ride) => (<>{ride?.mean?.license_plate} {ride?.mean?.seats ? "/ " + ride?.mean?.seats + " pt" : ""}</>),
    },
    {
        key: "driver",
        label: "Autista",
        filterable: true,
        filterOn: 'surname',
        render: (ride: Ride) => (<>{ride.driver?.surname}</>),
    },
    {
        key: "effort_hours",
        label: "Ore di impegno",
        filterable: true,
        sortable: true,
    },
    {
        key: "driving_hours",
        label: "Ore di guida",
        filterable: true,
        sortable: true,
    }
];

const RidesPage: FC = () => {
    return (
        <PageWrapper <Ride, Service>
            columns={columns}
            emptyEntity={emptyService}
            entityIcon={icon}
            viewApi={rideApi}
            viewDefaultSorters={{
                "start_departure_date": "ASC",
            }}
            entityApi={serviceApi}
            entityApiId="service_id"
            labels={{
                icon,
                singleEntityName,
                pluralEntityName
            }}
            form={RideFormBuilder()}
        />
    );
};

export { RidesPage }
